export default __webpack_public_path__ + "static/media/SpringBook_03.6579052b.png";